import { __awaiter } from "tslib";
import { useDispatch } from 'react-redux';
import { useOrderUpdate } from '../../../../Checkout/hooks';
import { ExareStatus } from '@websky/graphql';
import { clearExchangeVariants, clearPaymentStatus, setLoading, stopLoading, useExchange } from '@entities/exchange';
import { useRouter } from '@shared/lib/router';
export function useRefreshExchangeOrder() {
    const dispatch = useDispatch();
    const router = useRouter();
    const { onRefreshOrder } = useOrderUpdate();
    const { updateOrder } = useExchange();
    const onClearExchangeState = () => {
        dispatch(clearExchangeVariants());
        dispatch(clearPaymentStatus());
    };
    const onBackToOrder = () => __awaiter(this, void 0, void 0, function* () {
        yield updateOrder();
        router.navigate('/order');
    });
    const onFinishExchangeOrder = () => __awaiter(this, void 0, void 0, function* () {
        onClearExchangeState();
        yield onBackToOrder();
    });
    const onPollingOrder = (interval) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const order = yield onRefreshOrder();
        const lastExchange = (_b = (_a = order === null || order === void 0 ? void 0 : order.Order) === null || _a === void 0 ? void 0 : _a.exareInfo) === null || _b === void 0 ? void 0 : _b.lastExchange;
        if ((lastExchange === null || lastExchange === void 0 ? void 0 : lastExchange.status) === ExareStatus.Finished) {
            yield onFinishExchangeOrder();
        }
        else {
            setTimeout(() => onPollingOrder(interval * 1.5), interval * 1.5);
        }
    });
    const onRefreshExchangeOrder = (failedExchange) => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        dispatch(setLoading('all'));
        const order = yield onRefreshOrder();
        const lastExchange = (_d = (_c = order === null || order === void 0 ? void 0 : order.Order) === null || _c === void 0 ? void 0 : _c.exareInfo) === null || _d === void 0 ? void 0 : _d.lastExchange;
        if (failedExchange) {
            if (lastExchange) {
                onClearExchangeState();
            }
            else {
                yield onBackToOrder();
            }
        }
        else if (lastExchange && lastExchange.status === ExareStatus.Finished) {
            yield onFinishExchangeOrder();
        }
        else {
            setTimeout(() => onPollingOrder(500), 500);
        }
        dispatch(stopLoading());
    });
    return {
        onRefreshOrder,
        onRefreshExchangeOrder
    };
}
